import $dictionary from 'app/stores/$dictionary';

export const INFOBLOX_PORTAL_URL_US = 'https://portal.infoblox.com/';
export const INFOBLOX_PORTAL_URL_EU = 'https://portal.eu.infoblox.com/';
export const INFOBLOX_PORTAL_URL_OUR1 = 'https://env-5.test.infoblox.com';

/**
 * Infoblox hosts separate portals for US (iad1), EU (fra1), and test (our1) environments.
 * @returns {string} the correct Infoblox portal URL for the current environment
 */
export function getInfobloxPortalUrl() {
  // process.env.ENV_NAME isn't available in the browser; the dictionary carries the server's ENV_NAME
  const envName = $dictionary.get('envName');
  if (envName === 'EMEA-SaaS') {
    return INFOBLOX_PORTAL_URL_EU;
  }
  if (envName === 'OurPrem1') {
    return INFOBLOX_PORTAL_URL_OUR1;
  }
  return INFOBLOX_PORTAL_URL_US;
}
